module.exports = __webpack_public_path__ + "img/T1_ty_7.e3d36fdd.png";